module.exports = __webpack_public_path__ + "img/pasta_sliced.cb612efd.jpg";